module.exports = __webpack_public_path__ + "assets/img/Spintel-Content-Marketing-w960.d3ff3995.webp";